import React from 'react'
import MiniCardAnchorTag from './MiniCardAnchorTag'
import Carousel from './Carousel'
import MiniCardDiv from './MiniCardDiv'
import { shouldUseAnchorTag } from '../../domain/useCases/shouldUseAnchorTag'
const DEFAULT_CARD_COUNT_LIMIT = 50

const MiniCarousel = ({
  id = '',
  cards = [],
  title = '',
  onCardClick,
  cardLabelSize = 'small',
  pageType,
  forceAnchorTag = false,
  customCardCountLimit = DEFAULT_CARD_COUNT_LIMIT,
  hideTitle = false,
  hideEmptyCarouselComponent
}) => {
  if (cards.length === 0 && hideEmptyCarouselComponent) {
    hideEmptyCarouselComponent(true)
  }

  const CardsToDisplay = cards.map((card) => {
    if (
      shouldUseAnchorTag({
        card,
        pageType,
        forceAnchorTag,
        cardCountLimit: customCardCountLimit
      })
    ) {
      return (
        <MiniCardAnchorTag
          className="mr-4"
          key={card.slug}
          card={card}
          labelSize={cardLabelSize}
        />
      )
    }
    return (
      <MiniCardDiv
        className="mr-4"
        key={card.slug}
        card={card}
        labelSize={cardLabelSize}
        onCardClick={() => {
          onCardClick?.(card)
        }}
      />
    )
  })

  return (
    <Carousel
      id={id}
      title={title}
      itemsCount={cards.length}
      topArrowPosition="8"
      smallArrows
      titleClassName={'leading-8'}
    >
      {CardsToDisplay}
    </Carousel>
  )
}
export default MiniCarousel
